import React from 'react';

const field = (
    props
) => (
    <div className="col-lg-6 col-xs-12" onClick={() => {props.handleClick(props.type)}}>
        <div className={`card card-block p-35 clearfix item-selection ${props.type == props.value ? 'selected':null}`}>
            <div className="counter counter-md pull-xs-left text-xs-left">
                <div className="counter-number-group font-size-20">
                    <span className="counter-number-related font-size-16">{props.title}</span>
                </div>
                <div className="counter-label font-size-12">{props.description}</div>
            </div>
            <div className="pull-xs-right white">
                <i className="icon icon-circle icon-2x wb-check item-status" aria-hidden="true"></i>
            </div>
        </div>
    </div>
)

export default field;




// WEBPACK FOOTER //
// ./containers/recommendations/WidgetType.js